import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import $ from 'jquery'
import '@/assets/css/style.css'
import '@/assets/js/lib.js'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    inline: true,
    button: false,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: 'data-source'
  }
})

import axios from 'axios'
Vue.prototype.$axios = axios

Vue.config.productionTip = false

// 多语言
// 英文
import LangEn from '@/assets/lang/en'
// 中文
import LangZh from '@/assets/lang/zh'
// 多语言切换插件
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  messages: {
    'en': LangEn,
    'zh': LangZh
  }
})


//http请求封装
import $http from '@/request/request'
Vue.prototype.$http = $http;

import api from '@/request/api'

// 公用imageUrl
Vue.prototype.imageUrl = api.baseURL + '/jee-cms/sys/common/static/';
// 公用上传文件路径 uploadPath
Vue.prototype.uploadPath = api.baseURL + '/jee-cms/sys/common/upload';

// 定义一个混入对象
var myMixin = {
  directives: {
    'inview': {
      inserted: function (el, binding) {
        let self = this;
        let isShow = false;
        const scrollHandle = () => {
          let scrollTop = $(el).offset().top;
          let offsetTop = $(el).data('offsetTop') || $('.header').outerHeight();
          let offsetBottom = $(el).data('offsetBottom') || 0;
          let scroll = $(window).scrollTop();
          let winHeight = $(window).outerHeight();
          if ((scrollTop - scroll - offsetTop) >= 0 && scroll + winHeight - offsetBottom >= scrollTop) {
            if (isShow == false) {
              isShow = true;
              binding.value.show && binding.value.show(binding.value.ref);
            }
          } else {
            if (isShow == true) {
              isShow = false;
              binding.value.hide && binding.value.hide(binding.value.ref);
            }
          }
        }
        scrollHandle();
        $(window).scroll(scrollHandle);
      }
    }
  },
  methods: {
    showHandle(ref) {
      this.$refs[ref].start();
    }
  },
  computed: {
    langChange() {
      return (zh, en) => {
        let lang = this.$i18n.locale;
        if (lang == 'zh') {
          return zh || en;
        } else {
          return en || zh;
        }
      }
    }
  }

}
Vue.mixin(myMixin)



new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
